var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6545 12.7923C20.6401 11.9475 20.5537 11.0931 20.3809 10.2627C20.0257 8.54913 19.1041 7.24353 17.2561 6.74433C16.0513 6.41793 14.8369 6.43713 13.6321 6.75393C12.7297 6.98913 12.0049 7.47873 11.4001 8.26593C11.4001 8.05473 11.4001 7.24353 11.4001 6.65313H6.94092C6.94092 10.4547 6.94092 16.3731 6.94092 20.0211H11.4001C11.4001 18.0099 11.3905 15.0339 11.4049 13.1907C11.4145 12.3987 11.5969 11.6307 12.1105 10.9827C12.6481 10.3011 13.3921 10.1187 14.2225 10.2291C15.0337 10.3347 15.6097 10.7955 15.8065 11.5587C15.9649 12.1731 16.0561 12.8163 16.0657 13.4499C16.0897 15.2019 16.0561 18.1923 16.0465 20.0259H20.6689C20.6737 17.8947 20.6881 14.7651 20.6545 12.7923Z",
    fill: "#22A081"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.556885 6.64844C0.556885 8.60204 0.556885 11.5828 0.556885 13.3492C0.556885 15.1396 0.556885 18.058 0.556885 20.0212H5.06409C5.06888 16.3924 5.06888 10.3924 5.06409 6.65324H0.556885V6.64844Z",
    fill: "#22A081"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.82252 0C1.24812 0 -0.014278 1.2192 0.000121978 2.7312C0.014522 4.2288 1.24812 5.4336 2.77932 5.4384C4.34892 5.4384 5.59212 4.2528 5.60172 2.7456C5.60652 1.2288 4.36332 0 2.82252 0Z",
    fill: "#22A081"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.0ae1a05dd0c5a1b3d73702409684d539.svg";
export { ForwardRef as ReactComponent };